import { render, staticRenderFns } from "./permission-role.vue?vue&type=template&id=734aa14d&scoped=true"
import script from "./permission-role.vue?vue&type=script&lang=ts"
export * from "./permission-role.vue?vue&type=script&lang=ts"
import style0 from "./permission-role.vue?vue&type=style&index=0&id=734aa14d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734aa14d",
  null
  
)

export default component.exports